import * as AppConstants from "./AppConstants"
import { Indexable } from "./model"

const usingExplorer = () =>
    navigator.userAgent.indexOf(`MSIE `) > -1 ||
    navigator.userAgent.indexOf(`Trident/`) > -1

const chartHeight = (height: number) => {
    return usingExplorer() ? { height: height } : { maxHeight: height }
}
const chartWidth = (width: number) => {
    return usingExplorer() ? { width: width } : {}
}
const regioniPathMap: Indexable<string> = {
    "Valle d'Aosta": "path2902",
    "Valle d'Aosta/Vallée d'Aoste": "path2902",
    Piemonte: "path2910",
    Lombardia: "path2908",
    "Trentino-Alto Adige": "path2898",
    "Trentino-Alto Adige/Südtirol": "path2898",
    "Friuli Venezia Giulia": "g2981",
    "Friuli-Venezia Giulia": "g2981",
    Liguria: "path2914",
    "Emilia-Romagna": "path2916",
    Veneto: "g2985",
    Toscana: "g2992",
    Umbria: "path2920",
    Lazio: "path2928",
    Marche: "path2918",
    Abruzzo: "path2924",
    Molise: "path2926",
    Campania: "g3015",
    Basilicata: "path2932",
    Puglia: "path2934",
    Calabria: "path2936",
    Sicilia: "g3019",
    Sardegna: "g3044"
}

const regionColorsMultiYear: Indexable<string[]> = {
    numAddetti: ["#F5F7FC", "#B8C9ED", "#738FE3", "#335CD6", "#0033CC"],
    numPosizioni: ["#FCF2F2", "#F0B2B2", "#E68080", "#D94040", "#CF0D0D"],
    reddDic: ["#E6F0E6", "#B2D1B2", "#66A366", "#267D26", "#006600"],
    ricCompDic: ["#F6F2F9", "#DBCCE6", "#B799CD", "#814DA8", "#4B0082"],
    punteggioIsaAnom: ["#E6E6E6", "#B2B2B2", "#999999", "#595959", "#262626"]
}

const regionColors: Indexable<string[]> = {
    numeroAddetti: ["#F5F7FC", "#B8C9ED", "#738FE3", "#335CD6", "#0033CC"],
    numeroPosizioni: ["#FCF2F2", "#F0B2B2", "#E68080", "#D94040", "#CF0D0D"],
    redditi: ["#E6F0E6", "#B2D1B2", "#66A366", "#267D26", "#006600"],
    ricaviCompensi: ["#F6F2F9", "#DBCCE6", "#B799CD", "#814DA8", "#4B0082"],
    punteggioIsaAnomalie: [
        "#E6E6E6",
        "#B2B2B2",
        "#999999",
        "#595959",
        "#262626"
    ]
}

const regionLabels = {
    numeroAddetti: [
        "< 161194.01",
        "161194.01 - 200283.32",
        "200283.32 - 542466.15",
        "542466.15 - 681686.51",
        "681686.51 - 1501642.96"
    ],
    numeroPosizioni: [
        "< 75698",
        "75698 - 91512",
        "91512 - 244579",
        "244579 - 282938",
        "282938 - 626022"
    ],
    redditi: [
        "< 28147",
        "28147 - 30354",
        "30354 - 40931",
        "40931 - 47935",
        "47935 - 59851"
    ],
    ricaviCompensi: [
        "< 193089",
        "193089 - 213026",
        "213026 - 243917",
        "243917 - 273242",
        "273242 - 347090"
    ],
    punteggioIsaAnomalie: [
        "< 6.6",
        "6.6 - 6.68",
        "6.68 - 6.77",
        "6.77 - 6.84",
        "6.84 - 6.98"
    ]
}
const countValue = (value: number, dataType: string, counts: number[]) => {
    switch (dataType) {
        case "numeroAddetti":
            if (value < 161194.01) {
                counts[0]++
            } else if (value >= 161194.01 && value < 200283.32) {
                counts[1]++
            } else if (value >= 200283.32 && value < 542466.15) {
                counts[2]++
            } else if (value >= 542466.15 && value < 681686.51) {
                counts[3]++
            } else if (value >= 681686.51 && value <= 1501642.96) {
                counts[4]++
            }
            break
        case "numeroPosizioni":
            if (value < 75698) {
                counts[0]++
            } else if (value >= 75698 && value < 91512) {
                counts[1]++
            } else if (value >= 91512 && value < 244579) {
                counts[2]++
            } else if (value >= 244579 && value < 282938) {
                counts[3]++
            } else if (value >= 282938 && value <= 626022) {
                counts[4]++
            }
            break
        case "redditi":
            if (value < 28147) {
                counts[0]++
            } else if (value >= 28147 && value < 30354) {
                counts[1]++
            } else if (value >= 30354 && value < 40931) {
                counts[2]++
            } else if (value >= 40931 && value < 47935) {
                counts[3]++
            } else if (value >= 47935 && value <= 59851) {
                counts[4]++
            }
            break
        case "ricaviCompensi":
            if (value < 193089) {
                counts[0]++
            } else if (value >= 193089 && value < 213026) {
                counts[1]++
            } else if (value >= 213026 && value < 243917) {
                counts[2]++
            } else if (value >= 243917 && value < 273242) {
                counts[3]++
            } else if (value >= 273242 && value <= 347090) {
                counts[4]++
            }
            break
        case "punteggioIsaAnomalie":
            if (value < 6.6) {
                counts[0]++
            } else if (value >= 6.6 && value < 6.68) {
                counts[1]++
            } else if (value >= 6.68 && value < 6.77) {
                counts[2]++
            } else if (value >= 6.77 && value < 6.84) {
                counts[3]++
            } else if (value >= 6.84 && value <= 6.98) {
                counts[4]++
            }
            break
        default:
            break
    }
}
const getRegionColor = (
    value: number,
    dataType: any,
    fasciaPercentileArr: string[],
    isMultiAnno = false
) => {
    const rColor = isMultiAnno ? regionColorsMultiYear : regionColors
    let color = "white"
    let first = fasciaPercentileArr[0].replace("<", "").replace(" ", "")
    const length = fasciaPercentileArr.length
    for (let index = 0; index < fasciaPercentileArr.length; index++) {
        const element = fasciaPercentileArr[index]
        if (index == length - 1) {
            if (
                element != undefined &&
                value >= Number(element.split(" - ")[0]) &&
                value <= Number(element.split(" - ")[1])
            ) {
                color = rColor[dataType][index]
            }
        } else if (element != undefined && element.includes("-")) {
            if (
                value >= Number(element.split(" - ")[0]) &&
                value < Number(element.split(" - ")[1])
            ) {
                color = rColor[dataType][index]
            }
        } else if (element != undefined && !element.includes("-")) {
            if (value < Number(element.replace("<", "").replace(" ", ""))) {
                color = rColor[dataType][index]
            }
        }
    }

    return color
}


function generaSVGGrafico(svg: string) {
    let source = svg
    //add name spaces.
    if (!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
        source = source.replace(
            /^<svg/,
            '<svg xmlns="http://www.w3.org/2000/svg"'
        )
    }
    if (!source.match(/^<svg[^>]+"http:\/\/www\.w3\.org\/1999\/xlink"/)) {
        source = source.replace(
            /^<svg/,
            '<svg xmlns:xlink="http://www.w3.org/1999/xlink"'
        )
    }

    //add xml declaration
    source = '<?xml version="1.0" standalone="no"?>\r\n' + source
    //var svgData = $("#figureSvg")[0].outerHTML;
    var svgBlob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" })
    //var svgUrl = URL.createObjectURL(svgBlob);
    //console.log(svgUrl);
    // var downloadLink = document.createElement("a");
    // downloadLink.href = svgUrl;
    // downloadLink.download = "newesttree.svg";
    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    // document.body.removeChild(downloadLink);
    //const fileToUpload = new Blob([svg], {type: "image/svg"});
    return svgBlob
}

function getValoreHeader(
    codIsa: string | null | undefined,
    macroarea: string | null | undefined,
    multiAnno?: boolean
) {
    if (
        codIsa !== null &&
        codIsa !== undefined &&
        codIsa.length > 0 &&
        multiAnno
    )
        return ""
    else if (codIsa !== null && codIsa !== undefined && codIsa.length > 0)
        return codIsa.toUpperCase()
    else if (
        macroarea !== null &&
        macroarea !== undefined &&
        macroarea.length > 0
    )
        return macroarea.toUpperCase()
    else return AppConstants.TITLE_TUTTI_GLI_ISA.toUpperCase()
}

function getMob(nomeMob: string, listaMob: string | any[]) {
    let mobTrovato = null
    for (let i = 0; i < listaMob.length; i++) {
        let mob = listaMob[i]
        if (mob.nome.toUpperCase() === nomeMob.toUpperCase()) {
            mobTrovato = mob
            break
        }
    }
    if (mobTrovato !== null) {
        return mobTrovato
    } else {
        return undefined
    }
}

function getValoreMob(dati: any, tab: number, numTh: any) {
    let val = undefined
    let nonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE

    if (tab === 1) {
        switch (numTh) {
            case 1:
                val =
                    dati.mob1 !== undefined ? dati.mob1.valore : nonDisponibile
                break
            case 2:
                val =
                    dati.mob2 !== undefined ? dati.mob2.valore : nonDisponibile
                break
            case 3:
                val =
                    dati.mob3 !== undefined ? dati.mob3.valore : nonDisponibile
                break
            case 4:
                val =
                    dati.mob4 !== undefined ? dati.mob4.valore : nonDisponibile
                break
            case 5:
                val =
                    dati.mob5 !== undefined ? dati.mob5.valore : nonDisponibile
                break
            default:
                val =
                    dati.mob6 !== undefined ? dati.mob6.valore : nonDisponibile
                break
        }
    } else if (tab === 2) {
        switch (numTh) {
            case 1:
                val =
                    dati.mob7 !== undefined ? dati.mob7.valore : nonDisponibile
                break
            case 2:
                val =
                    dati.mob8 !== undefined ? dati.mob8.valore : nonDisponibile
                break
            case 3:
                val =
                    dati.mob9 !== undefined ? dati.mob9.valore : nonDisponibile
                break
            case 4:
                val =
                    dati.mob10 !== undefined
                        ? dati.mob10.valore
                        : nonDisponibile
                break
            case 5:
                val =
                    dati.mob11 !== undefined
                        ? dati.mob11.valore
                        : nonDisponibile
                break
            default:
                val =
                    dati.mob12 !== undefined
                        ? dati.mob12.valore
                        : nonDisponibile
                break
        }
    } else if (tab === 3) {
        switch (numTh) {
            case 1:
                val =
                    dati.mob13 !== undefined
                        ? dati.mob13.valore
                        : nonDisponibile
                break
            case 2:
                val =
                    dati.mob14 !== undefined
                        ? dati.mob14.valore
                        : nonDisponibile
                break
            case 3:
                val =
                    dati.mob15 !== undefined
                        ? dati.mob15.valore
                        : nonDisponibile
                break
            case 4:
                val =
                    dati.mob16 !== undefined
                        ? dati.mob16.valore
                        : nonDisponibile
                break
            case 5:
                val =
                    dati.mob17 !== undefined
                        ? dati.mob17.valore
                        : nonDisponibile
                break
            default:
                val =
                    dati.mob18 !== undefined
                        ? dati.mob18.valore
                        : nonDisponibile
                break
        }
    } else {
        val = nonDisponibile
    }

    if (val !== undefined && val !== nonDisponibile && val < 4)
        val = AppConstants.CARATTERE_RISERVATEZZA

    return val
}

function getMobArea(index: number): string {
    let area: string = ""
    switch (index) {
        case 0:
            area = "NORD-OVEST"
            break
        case 1:
            area = "NORD-EST"
            break
        case 2:
            area = "CENTRO"
            break
        case 3:
            area = "SUD"
            break
        case 4:
            area = "ISOLE"
            break

        default:
            break
    }
    return area
}

function trascodificaMacroArea(macroarea: string | null | undefined) {
    let output = undefined
    if (macroarea !== undefined && macroarea !== null) {
        switch (macroarea) {
            case AppConstants.MACRO_AGRICOLTURA:
                output = "A"
                break
            case AppConstants.MACRO_COMMERCIO:
                output = "M"
                break
            case AppConstants.MACRO_SERVIZI:
                output = "G"
                break
            case AppConstants.MACRO_MANIFATTURE:
                output = "D"
                break
            case AppConstants.MACRO_PROFESSIONISTI:
                output = "K"
                break
            default:
                output = null
                break
        }
    }
    return output
}

function getMapMob(listaMob: any[]) {
    console.log("Lista mob", listaMob)
    var map: Indexable<any> = {}
    for (let i = 0; i < listaMob.length; i++) {
        let mob = listaMob[i]
        console.log("Mob trovato: ", mob.nome)
        map[mob.nome] = mob.nome
    }

    return map
}

function valoreMobArea(
    macroareeTerritoriali:
        | { macroaree: string | any[] | null | undefined }
        | null
        | undefined,
    nomeMob: string | number,
    posArea: number
) {
    let output = null
    if (macroareeTerritoriali !== null && macroareeTerritoriali !== undefined) {
        if (
            macroareeTerritoriali.macroaree !== null &&
            macroareeTerritoriali.macroaree !== undefined &&
            macroareeTerritoriali.macroaree.length > 0
        ) {
            let macroarea = macroareeTerritoriali.macroaree[posArea]
            if (macroarea !== undefined) output = macroarea.mobs[nomeMob]
        }
    }

    if (output === null || output === undefined)
        output = AppConstants.ELEMENTO_NON_DISPONIBILE

    return output
}

export {
    regionColorsMultiYear,
    getValoreHeader,
    getMob,
    getValoreMob,
    trascodificaMacroArea,
    getMapMob,
    valoreMobArea,
    generaSVGGrafico,
    getRegionColor,
    regioniPathMap,
    regionColors,
    regionLabels,
    countValue,
    chartHeight,
    chartWidth,
    usingExplorer,
    getMobArea
}
